// extracted by mini-css-extract-plugin
export default {"backToTop":"ScrollButton_backToTop__JwBDR"};